module.exports = __webpack_public_path__ + "static/media/teilnahme_loesung.c0679d9e.jpg";